import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as $ from 'jquery';
import { App as Configuration } from './core/App';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import 'shared/view/styles';
import { store } from './core/store';

import 'shared/styles/app.scss';
import 'shared/styles/handsontable.scss';

window.$ = window.jQuery = $;

ReactDOM.render(
  <Configuration store={store}>
    <App />
  </Configuration>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
